module.exports = __webpack_public_path__ + "img/444.3b35bb6d.png";